import React, { useState, useEffect, useRef } from "react";
import UploadProgressModal from "./UploadProgressModal";
import $ from "jquery";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import { UploadType } from "../../utils/enums";

const CreateFilenameModal = () => {
  const {
    userToken,
    sharedObject,
    SetSharedObject,
  } = useUserStore((state) => ({
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    userRole: state.userRole,
    customerObj: state.customerObj,
    userSession: state.userSession,
  }));
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(true);
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [processing, SetProcessing] = useState(false);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("createFilenameModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    const onShow = () => {
      setError(false);
      setErrorMsg(false);
      setNewFileName("");
      setIsCheckboxChecked(true);
    };
    modalEl.addEventListener("shown.bs.modal", onShown);
    $(modalEl).on("show.bs.modal", onShow);
    return () => {
      modalEl.removeEventListener("shown.bs.modal", onShown);
      $(modalEl).off("show.bs.modal", onShow);
    };
  }, []);

  useEffect(() => {
    setError(false);
    return () => {
      setError(false);
    };
  }, []);
    const validate = () => {
        const file = sharedObject.UploadStausObj.UploadFile;
        const name = isCheckboxChecked ? file.name.trim() : newFileName.trim();

        // Must end with .csv and contain only valid chars before the extension
        const regex = /^[a-zA-Z0-9_.-]+\.csv$/;

        return regex.test(name);
    };
    
  //upload handler
  const InitiateUpload = async () => {
    //validates inputted string
    if (validate() === true) {
      const file = sharedObject.UploadStausObj.UploadFile;
      //check if filename exists
      var fileExists;
      if (isCheckboxChecked === true) {
        fileExists = await checkIfFileExists(file.name);
      } else {
        fileExists = await checkIfFileExists(newFileName);
      }
      if (fileExists === false) {
        uploadFunc();
      } else if (fileExists === true) {
        setError(true);
        setErrorMsg("File name already exists.");
      }
    } else {
      //throws error if validation fails
      setError(true);
      setErrorMsg(
        "File name can only use letters, numbers, hyphens, underscores, no spaces, and must add .csv extension."
      );
    }
  };

  const checkIfFileExists = async (filename) => {
    SetProcessing(true);
    let call = "/uploadStatus/CheckIfFileExists?fileName=" + filename;
    const res = await CallAPI(call, false, "get", userToken);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      return res.data.data;
    } else {
      setError(true);
      setErrorMsg("An unexpected issue has occurred. Please contact support for further assistance.");
      SetProcessing(false);
      return null;
    }
  };

  const uploadFunc = async () => {
    SetProcessing(true);
    let url;
    if (sharedObject.UploadStausObj.UploadType === UploadType.AddOrganizations) {
      url = `/uploadStatus/PostUploadStatusFile?type=${UploadType.AddOrganizations}&organizationId=${sharedObject.UploadStausObj.OrganizationId}`;
    } else if (
      sharedObject.UploadStausObj.UploadType === UploadType.AddOrganizationEmails
    ) {
      let emailType = UploadType.AddOrganizationEmails;
      if (sharedObject.UploadStausObj.UploadOption === "Delete") {
        emailType = UploadType.DeleteOrganizationEmails;
      }
      url = `/uploadStatus/PostUploadStatusFile?type=${emailType}&vendorId=${sharedObject.UploadStausObj.VendorId}`;
    } else {
      let userType = UploadType.AddUsers;
      if (sharedObject.UploadStausObj.UploadOption === "Delete") {
        userType = UploadType.DeleteUsers;
      }
      url =
        `/uploadStatus/PostUploadStatusFile?type=${userType}
        &organizationId=${sharedObject.UploadStausObj.OrganizationId}
        &isSendNotification=${sharedObject.UploadStausObj.isSendNotification}`;
    }

    const file = sharedObject.UploadStausObj.UploadFile;
    const bodyFormData = new FormData();
    const finalName = (isCheckboxChecked ? file.name : newFileName).trim();
    bodyFormData.append("file", file, finalName);

    const res = await CallAPI(url, bodyFormData, "post", userToken, true);

    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      $("#createFilenameModal").modal("hide");
      $("#uploadProgressModal").modal("show");
      SetProcessing(false);
    } else if (res.status === "VALIDATIONERROR") {
      setError(true);
      setErrorMsg(
        "CSV file failed validation. File does not match the upload template."
      );
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      setError(true);
      setErrorMsg("An unexpected issue has occurred.");
      SetProcessing(false);
    }
  };
  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked);
    if (e.target.checked) {
      setIsInputDisabled(true); // disable text input when checkbox is checked
    } else {
      setIsInputDisabled(false);
    }
  };
  const handleInputFocus = () => {
    if (!isInputDisabled) {
      setIsCheckboxChecked(false); // uncheck and disable the checkbox when input is focused
    }
    };
  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
    $('#createFilenameModal').modal('hide');
};
  return (
    <div className="CreateFilenameModal">
      <div
        className="modal fade"
        id="createFilenameModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="upload-new-filename-title"
        aria-describedby="uploadCreateFilenameModalDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="upload-new-filename-title">
                Upload Filename
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close upload create new filename"
                onClick={CloseModal}
                disabled={processing}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
               <p id="uploadCreateFilenameModalDesc" className="sr-only">
                Choose to keep the original file name or enter a new name for
                your upload file. It must be an MS Excel file and end in .csv extension.
              </p>
              <div className="modal-content-body">
                <p className="descript-container">
                  Enter a new name to identify your upload file once it has been
                  queued in the upload status page.
                </p>
                <fieldset>
                    <legend className="sr-only">Upload filename options</legend>
                    <div className="modal-content-form">
                      <label htmlFor="SameFilename">Keep filename</label>
                      <input
                        id="SameFilename"
                        name="SameFilename"
                        type="checkbox"
                        className="form-control"
                        checked={isCheckboxChecked}
                        aria-describedby="currentFileNameDesc"
                        ref={firstFocusRef}
                        onChange={handleCheckboxChange}
                      />
                      <div id="currentFileNameDesc" className="sub-catg">
                        {sharedObject?.UploadStausObj?.UploadFile?.name}
                      </div>
                    </div>
                    <div className="modal-content-form">
                      <label htmlFor="NewFileName">Create a new filename</label>
                      <input
                        name="NewFileName"
                        type="text"
                        className="form-control"
                        placeholder="Must include .csv"
                        disabled={isCheckboxChecked}
                        onFocus={handleInputFocus}
                        aria-disabled={isCheckboxChecked}
                        aria-describedby={
                            error ? "newFileNameError" : "newFileNameHint"
                          }
                        value={newFileName}
                        onChange={(el) => {
                          setNewFileName(el.target.value);
                          setError(false);
                        }}
                      />
                      <span id="newFileNameHint" className="sr-only">
                          File name must end in .csv and contain only letters,
                          numbers, hyphens, or underscores with no spaces.
                    </span>
                      <div className="field-wrapper sp-margin3 descript-container">
                        Uploading may take several minutes to hours depending on the
                        number of records and timeframe.
                      </div>
                    </div>
                </fieldset>
                {error ? (
                  <div 
                    className="alert alert-danger"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    id="newFileNameError"
                    >
                    {errorMsg}
                 </div>
                ) : null}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={(e) => {
                  InitiateUpload();
                  e.preventDefault();
                }}
                disabled={processing}
                aria-busy={processing}
              >
               {processing ? "Initiating..." : " Initiate Upload"}
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseModal}
                disabled={processing}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <UploadProgressModal />
    </div>
  );
};

export default CreateFilenameModal;
